import React from 'react';
import PropTypes from 'prop-types';
import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';
import {isFunction} from '../utils/helpers/boolean';

function NavList({expanded, items, renderItem}) {
  if (!isFunction(renderItem)) {
    return null;
  }
  return (
    <Collapse in={expanded}>
      <List sx={{p: 0}}>{items.map(renderItem)}</List>
    </Collapse>
  );
}

NavList.propTypes = {
  expanded: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  renderItem: PropTypes.func.isRequired,
};

export default NavList;
